module.exports = __webpack_public_path__ + "static/best-biker-2-b59e3e62d27e48c97f6540fd8341345f.jpg";